import React from 'react';
import { useIntl } from 'react-intl';

import { NotificationPreferences } from './components';
import { messages } from './NotificationPreferencesScreen.messages';

// ─────────────────────────────────────────────────────────────────────

export const NotificationPreferencesLoading = () => {
  const { formatMessage } = useIntl();

  return (
    <NotificationPreferences.Container title={formatMessage(messages.title)}>
      <NotificationPreferences.Skeleton />
      <NotificationPreferences.Skeleton />
    </NotificationPreferences.Container>
  );
};
